import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const IntroText = styled.div`
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
  color: ${({ theme }) => theme.text.actionBar};
`;
